import { defineStore } from "pinia";
import { ref } from "vue";

export const useSearchStore = defineStore("search", () => {
    const query = ref("");
    const searchOnlyParameter = ref(false)

    const resetSearch = () => {
        query.value = ''
        searchOnlyParameter.value = false
    }

    return { query, searchOnlyParameter, resetSearch }
});
